import { render, staticRenderFns } from "./CardPress.vue?vue&type=template&id=17314ba9&"
import script from "./CardPress.vue?vue&type=script&lang=js&"
export * from "./CardPress.vue?vue&type=script&lang=js&"
import style0 from "./CardPress.vue?vue&type=style&index=0&id=17314ba9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./CardPress.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports